<template>
	<div class="page">
		<div class="searchBox">
			<el-form>
				<el-row>
					<el-col :span="6">
						<el-form-item>
							<el-input style="width:200px;margin-right: 10px;" placeholder="请输入关键字" v-model="keyword" size="small" clearable></el-input>
							<el-button @click="changeSearch" type="warning" size="small">搜索</el-button>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item label="排序" :label-width="'50px'">
							<el-select style="width:130px" v-model="desc" @change="changeDesc" size="small">
								<el-option
								v-for="item in [{value:true,label:'时间由近及远'},{value:false,label:'时间由远及近'}]"
								:key="item.value"
								:label="item.label"
								:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="3">
						<el-form-item label="" :label-width="'20px'">
							<el-popover placement="bottom" title="" width="600" trigger="click" v-model="screenState">
								<el-button type="warning" slot="reference" size="small">筛选</el-button>
								<div class="screenBoxSignatureFileList">
									<div class="screenLine">
										<div class="screenLabel">业务分类:</div>
										<div class="screenValue">
											<div class="screenItem" :class="[type.indexOf(item.id)>-1?'active':'']" @click="clickType(item)" v-for="(item,index) in $types.fileTemplate_type" :key="index">{{item.name}}</div>
										</div>
										<div class="screenType">(多选)</div>
									</div>
									<div class="screenLine">
										<div class="screenLabel">印章类型:</div>
										<div class="screenValue">
											<div class="screenItem" :class="[signType.indexOf(item.id)>-1?'active':'']" @click="clickSignType(item)" v-for="(item,index) in $types.signature_type" :key="index">{{item.name}}</div>
										</div>
										<div class="screenType">(多选)</div>
									</div>
									<div class="screenLine" v-if="$buttonAuthority('file-fileList-shop')">
										<div class="screenLabel">门店:</div>
										<div class="screenValue">
											<div class="screenItem" :class="[shopId_arr.indexOf(item.shopId)>-1?'active':'']" @click="clickShopId_arr(item)"
											v-for="(item,index) in $types.physicalShops" :key="index"
											>{{item.shopName}}</div>
										</div>
										<!-- <div class="screenType">(多选)</div> -->
									</div>
									<div class="screenLine">
										<div class="screenLabel">下单时间:</div>
										<div class="screenValue">
											<el-date-picker v-model="createTime" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" size="mini" style="width:250px;" @change="changeCreateTime">
											</el-date-picker>
										</div>
									</div>
									<div class="screenLine">
										<div class="screenLabel">签署时间:</div>
										<div class="screenValue">
											<el-date-picker v-model="signTime" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" size="mini" style="width:250px;" @change="changeSignTime">
											</el-date-picker>
										</div>
									</div>
									<!-- <div class="screenBtnLine">
										<el-button slot="reference" size="mini">取消</el-button>
										<el-button type="primary" slot="reference" size="mini" @click="closeScreen">确定</el-button>
									</div> -->
								</div>
							</el-popover>
						</el-form-item>
					</el-col>
					<el-col :span="3" :offset="8">
						<el-form-item label="" :label-width="'80px'">
							<el-button size="small" @click="down">下载</el-button>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<div class="tabLine">
			<div class="tabItem" :class="[curTabIndex==1?'active':'']" @click="changeTabIndex(1)">全部</div>
			<div class="tabItem" :class="[curTabIndex==2?'active':'']" @click="changeTabIndex(2)">待签署</div>
			<div class="tabItem" :class="[curTabIndex==3?'active':'']" @click="changeTabIndex(3)">已签署</div>
			<div class="tabItem" :class="[curTabIndex==6?'active':'']" @click="changeTabIndex(6)">待完善</div>
			<div class="tabItem" :class="[curTabIndex==5?'active':'']" @click="changeTabIndex(5)">已失效</div>
		</div>
		<div class="tableBox">
			<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" :selectable="function(row){return row.isCompleteInfo===true&&row.isSignName===true}">
				</el-table-column>
				<el-table-column label="序号" width="50">
					<template slot-scope="props">
						{{parseInt(props.$index+1)}}
					</template>
				</el-table-column>
				<el-table-column label="文件编号" prop="contractNum" >
				</el-table-column>
				<el-table-column label="业务类型" prop="medicalServiceName" width="70">
					<template slot-scope="props">
						{{$types.get_fileTemplate_type(props.row.contractType)}}
					</template>
				</el-table-column>
				<el-table-column label="门店" prop="medicalServiceName" v-if="$buttonAuthority('file-fileList-shop')" width="70">
					<template slot-scope="props">
						{{$public.getShopNameById(props.row.shopId)}}
					</template>
				</el-table-column>
				<el-table-column label="顾客" prop="memberName" >
				</el-table-column>
				<el-table-column label="手机号" prop="memberMobile" >
				</el-table-column>
				<el-table-column label="宠物" prop="petName" >
				</el-table-column>
				<el-table-column label="签署状态" prop="birthDay" >
					<template slot-scope="props">
						<span v-if="props.row.state===2" style="color:#F56C6C;">已失效</span>
						<span v-if="props.row.state===1">
							<span v-if="props.row.signState===1" style="color:#F56C6C;">待签署</span>
							<span v-if="props.row.signState===2">已签署</span>
							<span v-if="props.row.signState===3">已领走</span>
						</span>
					</template>
				</el-table-column>
				
				<el-table-column label="完善状态" prop="birthDay" >
					<template slot-scope="props">
						<span v-if="props.row.isCompleteInfo===true">已完善</span>
						<span v-else style="color:#F56C6C;">未完善</span>
					</template>
				</el-table-column>
				<el-table-column label="下单时间" prop="birthDay" >
					<template slot-scope="props">
						{{props.row.businessTime?$public.FTime(props.row.businessTime,'YYYY-MM-DD') :'--' }}
					</template>
				</el-table-column>
				<el-table-column label="合同生成时间" prop="typeName" >
					<template slot-scope="props">
						<div>{{$public.FTime(props.row.createTimeStamp,'YYYY-MM-DD')}}</div>
					</template>
				</el-table-column>
				<el-table-column label="签署时间" >
					<template slot-scope="props">
						<div>{{$public.FTime(props.row.signTime,'YYYY-MM-DD')}}</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="120">
					<template slot-scope="props">
						<!-- <el-button type="text" size="mini" @click="$router.push({path:'/yiliao/ylfwSee?id='+props.row.id})">签约</el-button> -->
						<el-button type="text" size="mini" @click="see(props.row)">查看</el-button>
						<el-button v-if="props.row.state === 1" type="text" size="mini" @click="toVoid(props.row)">作废</el-button>
						<el-button type="text" size="mini" @click="del(props.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<page style="padding:10px 0;background-color: #fff;" :page="page.page" :total="page.total" @change="changePage"></page>
		</div>
	</div>
</template>
<script>
	import page from "../../components/page.vue"
	export default {
		components:{page},
		data(){
			return{
				// 筛选
				keyword:'',
				signState:0, 
				state:0, 
				completeState:0,
				
				desc:true,
				screenState:false,
				type:[],
				signType:[],
				shopId_arr:[],
				createTime:'',
				signTime:'',
				
				curTabIndex:1,
				
				tableData:[],
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				// 下载
				downList:[],
			}
		},
		computed:{
			curShopId(){
				return this.$store.state.shopId;
			},
		},
		mounted(){
			this.getTableData();
			if(this.$buttonAuthority('file-fileList-shop')){
				this.shopId_arr = ['']
			}else{
				this.shopId_arr = [this.curShopId]
			}
		},
		methods: {
			// 切换tab
			changeTabIndex(i){
				this.curTabIndex = i;
				if(i===1){
					this.signState = 0;
					this.state = 0;
					this.completeState = 0;
				}else if(i===2){
					this.signState = 1;
					this.state = 1;
					this.completeState = 0;
				}else if(i===3){
					this.signState = 2;
					this.state = 1;
					this.completeState = 0;
				}else if(i===4){
					this.signState = 3;
					this.state = 1;
					this.completeState = 0;
				}else if(i===5){
					this.signState = 0;
					this.state = 2;
					this.completeState = 0;
				}else if(i===6){
					this.signState = 0;
					this.state = 1;
					this.completeState = 1;
				}
				this.page.page = 1;
				this.getTableData();
			},
			// 关键字
			changeSearch(){
				this.page.page = 1;
				this.getTableData();
			},
			changeDesc(){
				this.page.page = 1;
				this.getTableData();
			},
			// 筛选
			closeScreen(){
				this.screenState=false;
			},
			clickType(item){
				let index = -1;
				for(let i=0;i<this.type.length;i++){
					if(this.type[i]===item.id){
						index=i
					}
				}
				if(index===-1){
					this.type.push(item.id)
				}else{
					this.type.splice(index,1)
				}
				this.page.page = 1;
				this.getTableData();
			},
			clickSignType(item){
				let index = -1;
				for(let i=0;i<this.signType.length;i++){
					if(this.signType[i]===item.id){
						index=i
					}
				}
				if(index===-1){
					this.signType.push(item.id)
				}else{
					this.signType.splice(index,1)
				}
				this.page.page=1;
				this.getTableData()
			},
			clickShopId_arr(item){
				if(item.shopId===this.shopId_arr[0]){
					this.shopId_arr = [''];
				}else{
					this.shopId_arr = [item.shopId];
				}
				this.page.page=1;
				this.getTableData()
			},
			changeCreateTime(){
				this.page.page=1;
				this.getTableData()
			},
			changeSignTime(){
				this.page.page=1;
				this.getTableData()
			},
			// 改变分页
			changePage(num){
				this.page.page = num;
				this.getTableData();
			},
			getTableData(){
				let params = {
					"keyword": this.keyword,
					shopId:this.shopId_arr[0],
					"contractType": this.type,  // 
					"sealType": this.signType,  // 
					"beginTime": "",
					"endTime": "",
					"signBeginTime": "", // 签约开始时间
					"signEndTime": "",  // 签约结束时间
					"desc":this.desc,
					"signState":this.signState,  // 0不限；1待签署；2已签署；3已领走
					"state":this.state, // 0不限 1待完成；2已完成；3失效
					completeState:this.completeState,  // 0不限；1未完善；2已完善
					isLink:-1,   // -1不限；0未关联；1已关联
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
				}
				if(this.createTime&&this.createTime.length===2){
					params.beginTime=(''+new Date(this.createTime[0]).getTime()).substr(0,10);
					params.endTime=(''+new Date(this.createTime[1]).getTime()).substr(0,10);
				}
				if(this.signTime&&this.signTime.length===2){
					params.signBeginTime=(''+new Date(this.signTime[0]).getTime()).substr(0,10);
					params.signEndTime=(''+new Date(this.signTime[1]).getTime()).substr(0,10);
				}
				let loading=this.$loading();
				this.$http.post('/api/Contract/Order/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
			// 查看
			see(row){
				let loading = this.$loading();
				this.$http.get('/api/Contract/Order/Detail', {contractNum:row.contractNum}).then(res => {
					loading.close()
					if (res.code == 0) {
						// this.pdfUrl = res.data.contractPdfUrl;
						window.open(res.data.signContractPdfUrl)
					}
				})
			},
			// 作废
			toVoid(row){
				this.$confirm('确定要作废吗?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get('/api/Contract/Order/Update', {contractNum:row.contractNum}).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.getTableData();
						}
					})
				})
			},
			// 删除
			del(row){
				this.$confirm('确定要删除?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get('/api/Contract/Order/Delete', {contractNum:row.contractNum}).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '删除成功',
								type: 'success'
							});
							this.getTableData();
						}
					})
				})
			},
			// 下载
			handleSelectionChange(val) {
				this.downList = val;
			},
			down(){
				if(this.downList.length===0){
					this.$message({
						message: '请选择要下载的文件',
						type: 'error'
					});
					return ;
				}
				for(let i=0;i<this.downList.length;i++){
					const iframe = document.createElement("iframe");
					iframe.style.display = "none"; 
					iframe.style.height = 0; 
					iframe.src = this.downList[i].signContractUrl;
					document.body.appendChild(iframe);
					setTimeout(()=>{
						iframe.remove();
					},100000);
				}
			},
		},
	}
</script>
<style scoped lang="scss">
.page{
	.searchBox {
		.el-form-item {
			margin-bottom: 0;
		}
	}
	.tabLine {
		margin-top: 12px;
		display: flex;
		
		.tabItem {
			padding: 0 16px;
			line-height: 36px;
			text-align: center;
			border-right: 1px solid #F2F2F2;
			cursor: pointer;
			font-size: 14px;
			background-color: #fff;
			&.active {
				color: $mainColor;
			}
		}
	}
	.tableBox{
		border-top: 1px solid #F2F2F2;
	}
}
</style>
<style lang="scss">
	.screenBoxSignatureFileList{
		.screenLine{
			display: flex;padding:5px 0;
			.screenLabel{
				font-size: 14px;color:#2A2A2A;width:70px;flex-grow: 0;flex-shrink: 0;line-height: 24px;
			}
			.screenValue{
				display: flex;
				.screenItem{
					padding:0 10px;box-sizing: border-box;height: 24px;line-height: 22px;text-align: center;margin-right: 15px;border:1px solid rgba(0, 0, 0, 0.15);border-radius: 2px;background-color: #fff;font-size: 14px;cursor: pointer;
					&.active{
						color:#fff;background-color: $mainColor;border-color:$mainColor;
					}
				}
			}
			.screenType{
				font-size: 14px;color:#2A2A2A;width:50px;flex-grow: 0;flex-shrink: 0;
			}
		}
		.screenBtnLine{
			text-align: right;padding-top:10px;margin-top:10px;border-top:1px solid rgba(0, 0, 0, 0.06);
		}
	}
</style>
